import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
  overflow: hidden;
  white-space: nowrap;
`;

const IconWrapper = styled.span<{ priority?: number }>`
  font-size: 27px;
  color: #666;
  opacity: 0.5;
  flex-shrink: 0;

  /* Hide icons from lowest to highest priority as screen gets smaller */
  /* Large screens: progressively hide 1-6 */
  ${props => props.priority === 1 && '@media (max-width: 1200px) { display: none; }'}
  ${props => props.priority === 2 && '@media (max-width: 1150px) { display: none; }'}
  ${props => props.priority === 3 && '@media (max-width: 1100px) { display: none; }'}
  ${props => props.priority === 4 && '@media (max-width: 1050px) { display: none; }'}
  ${props => props.priority === 5 && '@media (max-width: 1000px) { display: none; }'}
  ${props => props.priority === 6 && '@media (max-width: 950px) { display: none; }'}
  /* Side-by-side layout (950-626px): progressively hide 7-9 to prevent overflow */
  ${props => props.priority === 7 && '@media (max-width: 900px) { display: none; }'}
  ${props => props.priority === 8 && '@media (max-width: 850px) { display: none; }'}
  ${props => props.priority === 9 && '@media (max-width: 800px) { display: none; }'}
  /* At 626-625px: 6 icons visible (10-15) */
  /* Then show more when layout wraps at 625px */
  ${props => props.priority === 7 && `@media (max-width: ${breakpoints.maxWidthXs}) { display: block; }`}
  ${props => props.priority === 8 && `@media (max-width: ${breakpoints.maxWidthXs}) { display: block; }`}
  ${props => props.priority === 9 && `@media (max-width: ${breakpoints.maxWidthXs}) { display: block; }`}
  /* Wrapped layout (below 625px): progressively hide 7-11 again */
  ${props => props.priority === 7 && '@media (max-width: 575px) { display: none; }'}
  ${props => props.priority === 8 && '@media (max-width: 525px) { display: none; }'}
  ${props => props.priority === 9 && '@media (max-width: 475px) { display: none; }'}
  ${props => props.priority === 10 && '@media (max-width: 425px) { display: none; }'}
  ${props => props.priority === 11 && '@media (max-width: 375px) { display: none; }'}
  /* Priorities 12-15: always visible */
`;

export const IconList: React.FC = () => {
  return (
    <IconContainer>
      {/* Industry-relevant custom icons - hide progressively on smaller screens */}
      <IconWrapper priority={15}>
        <i className="fa-sharp fa-solid fa-lightbulb-exclamation-on"></i>
      </IconWrapper>
      <IconWrapper priority={14}>
        <i className="fa-sharp fa-solid fa-money-bill-trend-up"></i>
      </IconWrapper>
      <IconWrapper priority={13}>
        <i className="fa-sharp fa-solid fa-chart-waterfall"></i>
      </IconWrapper>
      <IconWrapper priority={12}>
        <i className="fa-sharp fa-solid fa-comments"></i>
      </IconWrapper>
      <IconWrapper priority={11}>
        <i className="fa-sharp fa-solid fa-clipboard-list"></i>
      </IconWrapper>
      <IconWrapper priority={10}>
        <i className="fa-sharp fa-solid fa-pen-nib"></i>
      </IconWrapper>
      <IconWrapper priority={9}>
        <i className="fa-sharp fa-solid fa-paintbrush"></i>
      </IconWrapper>
      <IconWrapper priority={8}>
        <i className="fa-sharp fa-solid fa-piggy-bank"></i>
      </IconWrapper>
      <IconWrapper priority={7}>
        <i className="fa-sharp fa-solid fa-chart-user"></i>
      </IconWrapper>
      <IconWrapper priority={6}>
        <i className="fa-sharp fa-solid fa-stethoscope"></i>
      </IconWrapper>
      <IconWrapper priority={5}>
        <i className="fa-sharp fa-solid fa-user-doctor"></i>
      </IconWrapper>
      <IconWrapper priority={4}>
        <i className="fa-sharp fa-solid fa-notes-medical"></i>
      </IconWrapper>
      <IconWrapper priority={3}>
        <i className="fa-sharp fa-solid fa-house-building"></i>
      </IconWrapper>
      <IconWrapper priority={2}>
        <i className="fa-sharp fa-solid fa-pen-ruler"></i>
      </IconWrapper>
      <IconWrapper priority={1}>
        <i className="fa-sharp fa-solid fa-camera"></i>
      </IconWrapper>
    </IconContainer>
  );
};